<template>
    <div class="main-content">
        <b-card class="p-4 pb-5">
            <h3>PLANO ESSENCIAL</h3>

            <div class="d-flex flex-column mt-5 pb-5">
                <div class="d-flex align-items-center">
                    <i class="i-Medal-2" style="font-size: 30px; color: cornflowerblue;"></i>
                    <div class="lead">
                        Licença para 10 usuários
                    </div>
                </div>

                <div class="mt-2">
                    Você está em nosso <strong>Plano Essencial</strong>
                </div>

            </div>

            <div class="mt-4 mb-5">
                <a class="text-mute" href="#">
                    Desejo cancelar minha conta
                </a>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'Plan',
}
</script>
